import React, { Component } from 'react';
import { BrowserRouter as Router, Route} from "react-router-dom";
import './App.css';

import OrderForm from './containers/OrderForm'
import Orders from './containers/Orders'

class App extends Component {
  render() {
    return (
        <Router>
          <div className="App">

              <div className="right-top-buttons text-right">

              </div>

              <div className="mb-4 pb-2 border-bottom">
                  <h1>Bestelformulier <small className="text-muted">glas, rooster en draairamen</small></h1>
              </div>

              <Route exact path="/" component={OrderForm} />
              <Route path="/orders" component={Orders} />

          </div>
        </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js